import React from 'react';
import AssignmentStatusBadge from './AssignmentStatusBadge';
import type { AssignmentActivity } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { ASSIGNMENT_STATUSES, AssignmentWithCover } from '../types';
import { activitiesBadgeDict } from '../util';

type ActivityIconProps = {
  assignment: AssignmentWithCover;
  assignmentActivity: AssignmentActivity;
  status: ASSIGNMENT_STATUSES;
};

const ActivityIcon: React.FC<ActivityIconProps> = ({ assignment, assignmentActivity, status }) => {
  return (
    <>
      <AssignmentStatusBadge
        assignment={assignment}
        status={status}
        activityName={assignmentActivity.activity?.activityType?.name}
        style={{
          left: '50%',
          position: 'absolute',
          transform: 'translate(-50%)',
          zIndex: 1,
        }}
      />
      <img
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        src={activitiesBadgeDict[assignmentActivity.activity?.activityType?.name ?? '']}
      />
    </>
  );
};

export default ActivityIcon;
